import { Injectable, NgModule } from '@angular/core';
import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Observable } from 'rxjs';

// mocks SocialAuthService from angularx-social-login
@Injectable()
export class MockSocialAuthService {

  get initState(): Observable<boolean> {
    return new Observable();
  }

  signIn(providerId: string, signInOptions?: any): Promise<SocialUser> {
    return new Promise<SocialUser>((resolve, reject) => {
      const socialUser = new SocialUser();
      socialUser.idToken = 'token';
      resolve(socialUser);
    });
  }

  signOut(revoke?: boolean): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      resolve('');
    });
  }

}

@NgModule({
  providers: [{ provide: SocialAuthService, useClass: MockSocialAuthService }]
})
export class MockSocialLoginModule {
}
